/**
 * 若依管理端 URL（与 VITE_RUOYI_ADMIN_URL、主站代理 /admin 一致）
 */

export function getRuoyiAdminBaseUrl(): string {
  const raw = (import.meta.env.VITE_RUOYI_ADMIN_URL as string | undefined)?.trim()
  const base = raw || `${typeof window !== 'undefined' ? window.location.origin : ''}/admin/`
  return base.endsWith('/') ? base : `${base}/`
}

/** 若依控制台首页，如 http://localhost:8088/admin/index */
export function getRuoyiAdminIndexUrl(): string {
  return new URL('index', getRuoyiAdminBaseUrl()).href
}
